import { createSlice } from '@reduxjs/toolkit';


export const rtfoSlice = createSlice({
  name: 'rtfo',
  initialState: {
    value: null
  },
  reducers: {
    setPadData: (state, action) => {
      try {
        const padData = action.payload;
        if (!padData) {
          state.value = null;
        } else if (state?.value?.stageData && Object.keys(state?.value?.stageData)?.length > 0) {
          // const stageData = state.value.stageData;
          const currentStageName = state.value.currentStageName;
          state.value = padData;
          // state.value.stageData = stageData;
          state.value.currentStageName = currentStageName;
        } else {
          state.value = padData;
        };

      } catch (error) {
        return;
      };
    },
    setStagesData: (state, action) => { // bulk-set low resolution stage data
      try {
        const stagesData = action.payload;

        if (!stagesData?.length > 0) return;

        for (let stageData of stagesData) {
          if (stageData && state?.value && state?.value?.name) {
            const stageName = stageData.name;
  
            if (!state?.value?.stageData) state.value.stageData = {};
            
            if (state.value.stageData[stageName]?.highResolutionData && stageName === state.value.currentStageName) continue;
            state.value.stageData[stageName] = stageData;
            // state.value.stageData[stageName].highResolutionData = false;
            
            if (!state.value?.stages?.includes(stageName)) {
              state.value.stages.push(stageName);
            };
          };
        };

        if (!state.value.currentStageName) {
          state.value.currentStageName = stagesData?.[stagesData?.length - 1]?.name;
        };
        
        // state.value.isLoadingData = false;

      } catch (error) {
        console.log(error);
        return;
      };
    },
    deleteStagesData: (state, action) => { // delete stage data
      try {
        const stageNames = action.payload;

        if (!stageNames?.length > 0) return;

        for (const stageName of state.value.stages) {
          if (stageNames?.indexOf(stageName) !== -1 || !state.value.stageData[stageName]) continue;

          delete state.value.stageData[stageName]?.coldboreData;
          delete state.value.stageData[stageName]?.monitorData;
          state.value.stageData[stageName].highResolutionData = false;
        };

      } catch (error) {
        console.log(error);
        return;
      };
    },
    setStageData: (state, action) => {
      try {
        const stageData = action.payload.stageData;
        const isLiveMonitoring = action.payload.liveMonitoring;
        // const initialLoad = action.payload.initialLoad;
        const highResolutionData = action.payload.highResolutionData;
        const incrementalData = action.payload.incrementalData;
        const seismicData = action.payload.seismicData || stageData?.seismicData;

        if (stageData && stageData.name && !stageData?.seismicOnly) {
        // if (stageData && stageData.name && stageData.metrics && stageData.metrics?.stageTime > 0 && !stageData?.seismicOnly) {
          
          const stageName = stageData.name;

          if (!state?.value) {
            state.value = {
              name: stageName?.split('_')?.[0],
              stages: [],
              currentStageName: stageName
            };
          };


          if (!state?.value?.stageData) state.value.stageData = {};

          if (!state.value.stageData?.[stageName]) {
            state.value.stageData[stageName] = {coldboreData: [], monitorData: {}};
          };

          // if incremental data, append data to the existing data
          if (incrementalData) {
            const coldboreData = state.value.stageData[stageName]?.coldboreData?.length > 0 ? (state.value.stageData[stageName]?.coldboreData)?.concat(stageData?.coldboreData?.filter(d => d.timestamp > state.value.stageData[stageName]?.coldboreData?.slice(-1)?.[0]?.timestamp)) : stageData?.coldboreData;
            const monitorData = {};
            if (stageData?.monitorData) {
              for (let monitorWell of Object.keys(stageData?.monitorData)) {
                if (stageData?.monitorData?.[monitorWell]?.length > 0 && state.value.stageData[stageName]?.monitorData?.[monitorWell]?.length > 0) {
                  const filteredMonitorData = stageData?.monitorData?.[monitorWell]?.filter(d => d.timestamp > state.value.stageData[stageName]?.monitorData?.[monitorWell]?.slice(-1)?.[0]?.timestamp);
                  monitorData[monitorWell] = (state.value.stageData[stageName]?.monitorData?.[monitorWell]).concat(filteredMonitorData);
                } else if (stageData?.monitorData?.[monitorWell]?.length > 0 && !state.value.stageData[stageName]?.monitorData?.[monitorWell]?.length > 0) {
                  monitorData[monitorWell] = stageData?.monitorData?.[monitorWell];
                } else {
                  monitorData[monitorWell] = state.value.stageData[stageName]?.monitorData?.[monitorWell] || [];
                };
              };
            };
            state.value.stageData[stageName] = {...stageData, coldboreData, monitorData};
          } else {
            state.value.stageData[stageName] = stageData;
          };

          state.value.stageData[stageName].highResolutionData = highResolutionData;
          
          // Detect new stage
          if (!state.value?.stages?.includes(stageName)) {
            state.value.stages.push(stageName);
            if (isLiveMonitoring) {
              state.value.currentStageName = stageName;
            };

            // delete stage data for stages more than 5 away from the new stage
            if (state.value.stages.length > 5) {
              for (const stgName of state.value.stages) {
                const stageIndex = state.value.stages.indexOf(stgName);
                if (stageIndex < state.value.stages.length - 6 && state.value.stageData[stgName] && stgName !== stageName) {
                  delete state.value.stageData[stgName]?.coldboreData;
                  delete state.value.stageData[stgName]?.monitorData;
                  state.value.stageData[stgName].highResolutionData = false;
                }
              }
            }
          };

          // Update last modified timestamp
          state.value.lastModified = stageData?.lastModified;
        };

        if (seismicData && Object.keys(seismicData)?.length > 0 && state?.value && state?.value?.name !== 'Test') {
          state.value.lastModified = new Date()?.toLocaleString();
          state.value.seismicData = {
            realtime: state.value.seismicData?.realtime?.length > 0 ? (state.value.seismicData?.realtime?.filter(d => d.time < seismicData?.realtime?.slice(-1)?.[0]?.time) || [])?.concat(seismicData?.realtime) : seismicData?.realtime, 
            reprocessed: state.value.seismicData?.reprocessed?.length > 0 ? (state.value.seismicData?.reprocessed?.filter(d => d.time < seismicData?.reprocessed?.slice(-1)?.[0]?.time) || [])?.concat(seismicData?.reprocessed) : seismicData?.reprocessed,
            highPrecision: seismicData?.highPrecision
          };
          // if (incrementalData) {
          //   state.value.seismicData = {
          //     realtime: state.value.seismicData?.realtime?.length > 0 ? (state.value.seismicData?.realtime?.filter(d => d.time < seismicData?.realtime?.slice(-1)?.[0]?.time) || [])?.concat(seismicData?.realtime) : seismicData?.realtime, 
          //     reprocessed: state.value.seismicData?.reprocessed?.length > 0 ? (state.value.seismicData?.reprocessed?.filter(d => d.time < seismicData?.reprocessed?.slice(-1)?.[0]?.time) || [])?.concat(seismicData?.reprocessed) : seismicData?.reprocessed, 
          //   };
          // } else {
          //   state.value.seismicData = seismicData;
          // };
        };

        state.value.isLoadingData = false;
      } catch (error) {
        console.log(error);
        return;
      };
    },
    setCurrentStageName: (state, action) => {
      try {
        const stageName = action.payload;
        if (stageName) {
          state.value.currentStageName = stageName;
        };
      } catch (error) {
        console.log(error);
        return;
      };
    },
    setStageSpikesAndComments: (state, action) => {
      try {
        const stageName = action.payload?.stageName;
        const stageSpikes = action.payload?.stageSpikes;
        const stageComments = action.payload?.stageComments;

        if (stageName && stageSpikes && stageComments) {
          state.value.stageData[stageName].spikes = stageSpikes;
          state.value.stageData[stageName].comments = stageComments;
        };

      } catch (error) {
        console.log(error);
        return;
      };
    },
    setIsLoadingData: (state, action) => {
      try {
        if (!state.value) return;

        const isLoadingData = action.payload;

        state.value.isLoadingData = isLoadingData;
      } catch (error) {
        console.log(error);
        return;
      };
    },
    toggleStageStepdownLock: (state, action) => {
      try {
        const stageName = action.payload?.stageName;
        if (stageName && state.value.stageData[stageName]) {
          if (!state.value.stageData[stageName].stepdownLocked) {
            state.value.stageData[stageName].stepdownLocked = true;
          } else {
            state.value.stageData[stageName].stepdownLocked = false;
          };
        };
      } catch (error) {
        console.log(error);
        return;
      };
    },
    toggleStageFracModelLock: (state, action) => {
      try {
        const stageName = action.payload?.stageName;
        if (stageName && state.value.stageData[stageName]) {
          if (!state.value.stageData[stageName].fracModelLocked) {
            state.value.stageData[stageName].fracModelLocked = true;
          } else {
            state.value.stageData[stageName].fracModelLocked = false;
          };
        };
      } catch (error) {
        console.log(error);
        return;
      };
    }
    
  }
});

export const {
  setPadData,
  setStagesData,
  deleteStagesData,
  setStageData,
  setCurrentStageName,
  setStageSpikesAndComments,
  setIsLoadingData,
  toggleStageStepdownLock,
  toggleStageFracModelLock
} = rtfoSlice.actions;

export const selectRTFO = (state) => state.rtfo;

export default rtfoSlice.reducer;